import { useEffect, useRef, type ReactNode } from 'react';

export interface ProductDesignsEmbeddedBridgeProps {
    embedded?: boolean;
    /** True when this panel is the active Product designs tab */
    embeddedActive?: boolean;
    onEmbeddedFooterChange?: (footer: ReactNode | null) => void;
}

/** Pushes tab-specific footer actions into ProductDesignsModal when embedded. */
export function useProductDesignsEmbeddedFooter(
    embedded: boolean | undefined,
    embeddedActive: boolean | undefined,
    open: boolean,
    footer: ReactNode,
    onEmbeddedFooterChange?: (footer: ReactNode | null) => void,
    refreshKey?: string | number,
): void {
    const footerRef = useRef(footer);
    footerRef.current = footer;

    useEffect(() => {
        if (!embedded || !onEmbeddedFooterChange || !embeddedActive || !open) return;
        onEmbeddedFooterChange(footerRef.current);
        return () => onEmbeddedFooterChange(null);
    }, [embedded, embeddedActive, open, onEmbeddedFooterChange, refreshKey]);
}
